// @ts-nocheck
import inscriptionABI from "data/abi"
import { encodeFunctionData } from "viem"

export const getDataByEncodeFunctionData = (amount: BigInt, toAddr: string) => {
    const data = encodeFunctionData({
        abi: inscriptionABI,
        functionName: 'transfer',
        args: [toAddr, amount] 
    })
    return data
}